import React from "react";
import { Message as IMessage } from "Types/api/Messages";
import styled from "styled-components";

interface Props {
    message: IMessage;
    displayTime: boolean;
}

export const MessageBubble = styled("div")<{ user: any }>`
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    border-radius: 0.75rem;
    background-color: ${(props) => (props.user ? "#FFF" : props.theme.palette.cta.background)};
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%);
    width: fit-content;
    margin-top: 0.5em;
    overflow-wrap: anywhere;
    color: ${(props) => (props.user ? "black" : props.theme.palette.cta.text)};
`;

export const MessageWrapper = styled("div")<{ user: any }>`
    align-self: ${(props) => (props.user ? "flex-start" : "flex-end")};
    flex-direction: column;
    display: flex;
    align-items: ${(props) => (props.user ? "flex-start" : "flex-end")};
    ${(props) => (props.user ? "margin-right: 3rem;" : "margin-left: 3rem;")};
`;

const MessageTime = styled("div")<{ user: any }>`
    font-size: 0.75rem;
    color: gray;
    padding-top: 0.5em;
`;

export const Message = ({ message, displayTime }: Props) => {
    return (
        <MessageWrapper user={message.user}>
            <MessageBubble user={message.user}>{message.message}</MessageBubble>
            {displayTime && (
                <MessageTime user={message.user}>
                    {new Date(message.displayDate).toLocaleTimeString(undefined, {
                        hour: "numeric",
                        minute: "numeric",
                    })}
                </MessageTime>
            )}
        </MessageWrapper>
    );
};

export default Message;
